// Copyright 2023, mochabug AB
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

// @generated by protoc-gen-es v2.5.2 with parameter "target=ts,json_types=true,ts_nocheck=true"
// @generated from file mochabugapis/adapt/plugins/v1/service_binding.proto (package mochabugapis.adapt.plugins.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../../buf/validate/validate_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mochabugapis/adapt/plugins/v1/service_binding.proto.
 */
export const file_mochabugapis_adapt_plugins_v1_service_binding: GenFile = /*@__PURE__*/
  fileDesc("CjNtb2NoYWJ1Z2FwaXMvYWRhcHQvcGx1Z2lucy92MS9zZXJ2aWNlX2JpbmRpbmcucHJvdG8SHW1vY2hhYnVnYXBpcy5hZGFwdC5wbHVnaW5zLnYxIugBCg5TZXJ2aWNlQmluZGluZxItCgRuYW1lGAEgASgJQh+6SBxyGhABGGQyFF5bXyRhLXpdW18kYS16MC05XSokEjIKB3NlcnZpY2UYAiABKAlCH7pIHHIaEAEYZDIUXltfJGEtel1bXyRhLXowLTldKiRIABI9CgZvbmVfb2YYAyABKAsyKy5tb2NoYWJ1Z2FwaXMuYWRhcHQucGx1Z2lucy52MS5PbmVPZkJpbmRpbmdIABIVCghvcHRpb25hbBgEIAEoCEgBiAEBQhAKB2JpbmRpbmcSBbpIAggBQgsKCV9vcHRpb25hbCKmAgoMT25lT2ZCaW5kaW5nEjsKB29wdGlvbnMYASADKAlCKrpIJ5IBJAgBEBQYASIcchoQARhkMhReW18kYS16XVtfJGEtejAtOV0qJBI4CgdkZWZhdWx0GAIgASgJQiK6SB/YAQFyGhABGGQyFF5bXyRhLXpdW18kYS16MC05XSokSACIAQE6kgG6SI4BGosBChJkZWZhdWx0X2luX29wdGlvbnMSNE1ha2Ugc3VyZSB0aGF0IHRoZSBkZWZhdWx0IGV4aXN0cyBpbnNpZGUgdGhlIG9wdGlvbnMaPyFoYXModGhpcy5kZWZhdWx0KSB8fCB0aGlzLm9wdGlvbnMuZXhpc3RzKHgsIHggPT0gdGhpcy5kZWZhdWx0KUIKCghfZGVmYXVsdGIGcHJvdG8z", [file_buf_validate_validate]);

/**
 * A binding for a service. It can either reference a single service (via 'name')
 * or specify a one‑of group of available services (via 'one_of_binding').
 * The binding can also be marked as optional.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.ServiceBinding
 */
export type ServiceBinding = Message<"mochabugapis.adapt.plugins.v1.ServiceBinding"> & {
  /**
   * The binding name is what the plugin is referring to internally when using the service
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * The actual binding
   *
   * @generated from oneof mochabugapis.adapt.plugins.v1.ServiceBinding.binding
   */
  binding: {
    /**
     * A direct reference to a service definition.
     *
     * @generated from field: string service = 2;
     */
    value: string;
    case: "service";
  } | {
    /**
     * A one-of binding: a list of service choices.
     *
     * @generated from field: mochabugapis.adapt.plugins.v1.OneOfBinding one_of = 3;
     */
    value: OneOfBinding;
    case: "oneOf";
  } | { case: undefined; value?: undefined };

  /**
   * Whether the binding is optional.
   *
   * @generated from field: optional bool optional = 4;
   */
  optional?: boolean;
};

/**
 * A binding for a service. It can either reference a single service (via 'name')
 * or specify a one‑of group of available services (via 'one_of_binding').
 * The binding can also be marked as optional.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.ServiceBinding
 */
export type ServiceBindingJson = {
  /**
   * The binding name is what the plugin is referring to internally when using the service
   *
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * A direct reference to a service definition.
   *
   * @generated from field: string service = 2;
   */
  service?: string;

  /**
   * A one-of binding: a list of service choices.
   *
   * @generated from field: mochabugapis.adapt.plugins.v1.OneOfBinding one_of = 3;
   */
  oneOf?: OneOfBindingJson;

  /**
   * Whether the binding is optional.
   *
   * @generated from field: optional bool optional = 4;
   */
  optional?: boolean;
};

/**
 * Describes the message mochabugapis.adapt.plugins.v1.ServiceBinding.
 * Use `create(ServiceBindingSchema)` to create a new message.
 */
export const ServiceBindingSchema: GenMessage<ServiceBinding, {jsonType: ServiceBindingJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_plugins_v1_service_binding, 0);

/**
 * The one-of binding type.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.OneOfBinding
 */
export type OneOfBinding = Message<"mochabugapis.adapt.plugins.v1.OneOfBinding"> & {
  /**
   * List of available service names.
   *
   * @generated from field: repeated string options = 1;
   */
  options: string[];

  /**
   * an optional default that must lie in the options array
   *
   * @generated from field: optional string default = 2;
   */
  default?: string;
};

/**
 * The one-of binding type.
 *
 * @generated from message mochabugapis.adapt.plugins.v1.OneOfBinding
 */
export type OneOfBindingJson = {
  /**
   * List of available service names.
   *
   * @generated from field: repeated string options = 1;
   */
  options?: string[];

  /**
   * an optional default that must lie in the options array
   *
   * @generated from field: optional string default = 2;
   */
  default?: string;
};

/**
 * Describes the message mochabugapis.adapt.plugins.v1.OneOfBinding.
 * Use `create(OneOfBindingSchema)` to create a new message.
 */
export const OneOfBindingSchema: GenMessage<OneOfBinding, {jsonType: OneOfBindingJson}> = /*@__PURE__*/
  messageDesc(file_mochabugapis_adapt_plugins_v1_service_binding, 1);

